import styled from "styled-components"

export const Background = styled.div`
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`

export const CardDropdownContainer = styled.div`
  position: absolute;
  width: 240px;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  background: #fff;
  top: 80px;
  right: 0;
  z-index: 11;
  border-radius: 8px;
  margin-right: 24px;
`

export const CartItems = styled.div`
  width: 100%;
  height: calc(100% - 60px);
  padding: 16px;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const EmptyCartP = styled.p`
  font-size: 14px;
  font-weight: 400;
  margin: 50% auto;
  color: #565656;
`

export const ButtonWrapper = styled.div`
  width: calc(100% - 24px);
  height: 48px;
  border-radius: 4px;
  overflow: hidden;
`
